module.exports = __webpack_public_path__ + "img/book_1.3a1921f3.jpg";